import React from 'react'
import TableView from './table/TableView'

export default function AbandonCartPage() {
  return (
    <TableView />
  )
}
